import axios from "axios";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { httpService } from "../Axios/Axios";
import { useLoader } from "../../components/loader/loader";

const ErrorInterceptor = () => {
  const navigate = useNavigate();
  const { show, hide } = useLoader();
  useEffect(() => {
    const interceptor = httpService.interceptors.response.use(
      function (response: any) {
        console.log(response, "httpServiceresponseresponseresponseresponse");
        // Do something with response data
        return response;
      },
      function (error: { response: { status: any; }; }) {
        console.log(error, "httpServiceerrorerrorerrorerrorerrorerror");
        switch (error.response.status) {
          case 401:
            localStorage.clear();
            navigate("/login");
            hide();
            // alert("Sorry, Please login again to continue.");
            break;
          case 0:
            // alert("Please check internet connection!");
            break;
          case 400:
            // localStorage.clear();
            // navigate("/login");
            hide();
            // alert("Sorry, Please login again to continue.");
            break;
          default:
            // alert(error.response.data.message);
            break;
        }
        return Promise.reject(error);
      }
    );
    // const interceptor = axios.interceptors.response.use(
    //   (response) => {
    //     console.log(response, "responseresponseresponse");
    //     return response;
    //   },
    //   (error) => {
    //     console.log(error, "errorinterceptorerrorinterceptorerrorinterceptor");
    //     switch (error.response.status) {
    //       case 401:
    //         localStorage.clear();
    //         navigate("/login");
    //         alert("Sorry, Please login again to continue.");
    //         break;
    //       case 0:
    //         alert("Please check internet connection!");
    //         break;
    //       case 400:
    //         localStorage.clear();
    //         navigate("/login");
    //         alert("Sorry, Please login again to continue.");
    //         break;
    //       default:
    //         alert(error.response.data.message);
    //         break;
    //     }
    //     return Promise.reject(error);
    //   }
    // );

    return () => {
      axios.interceptors.response.eject(interceptor);
    };
  }, []);

  return null;
};

export default ErrorInterceptor;
